import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Card, CardBody, Form} from "reactstrap"
import _parseCode from './_parseCode'


class ScanCode extends Component {
    _handleSubmit = (e) => {
        e.preventDefault()

        const {onSubmit, value} = this.props
        try {
            const {index, number, code} = _parseCode(value)

            return onSubmit({number, index, code})
        } catch (err) {
            const {message} = err
            window.alert(`Lỗi: ${message}`)

            return this.props.onReset()
        }
    }

    _handleChangeInput = (e) => {
        const {value} = e.target

        const {onChange} = this.props
        if (typeof onChange === 'function') onChange(value)
    }

    render() {
        const {value} = this.props

        return (
            <div className="ScanCode">
                <Card>
                    <div className="card-header bg-success text-white header-elements-inline">
                        <h1 className="card-title">Quét hoặc nhập mã QR</h1>
                    </div>
                    <CardBody>
                        <Form className='d-flex justify-content-center' onSubmit={this._handleSubmit}>

                            <input className='InputSearch form-control' name='barcodeNumber'
                                   value={value}
                                   onChange={this._handleChangeInput}
                                   autoFocus/>
                        </Form>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

ScanCode.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
}

export default ScanCode
